<template>
    <div class="content">
        <div class="container-fluid">
          <div class="row align-items-center mb-1">
            <div class="col-md-6">
              <div class="h2">Upcoming Events</div>
            </div>
            <div class="col-md-2 offset-md-2 text-right center">
              <button type="submit" class="btn btn-primary btn-fill" @click="changeListOrder">Change Archive Order</button>
            </div>
            <div class="col-md-2 text-right center">
              <button type="submit" class="btn btn-primary btn-fill" @click="createEvent">Create Event</button>
            </div>
          </div>
<!--            <div class="row align-items-center mb-1">-->
<!--                <div class="col-md-6">-->
<!--                    <div class="h2">Upcoming Events</div>-->
<!--                </div>-->
<!--                <div class="col-md-3 offset-md-3 text-right center">-->
<!--                    <button type="submit" class="btn btn-primary btn-fill" @click="createEvent">Create Event</button>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="row align-items-center mb-1">-->
<!--              <div class="col-md-6">-->
<!--                <fg-select-->
<!--                  v-model="sortOderId"-->
<!--                  label="Archive Sort Order"-->
<!--                  :list="sortOrder"-->
<!--                  selectedKey="id"-->
<!--                >-->
<!--                </fg-select>-->
<!--              </div>-->
<!--              <div class="col-md-3 offset-md-3 text-right center">-->
<!--                <button type="button" class="btn btn-primary btn-fill" @click="updateOrder">Update Order</button>-->
<!--              </div>-->
<!--            </div>-->
            <div class="table-responsive text-center">
                <l-table class="table table-light  table-light table-bordered table-hover"
                         :columns="events.columns" :data="events.data">
                    <template slot="table-row" v-if="events.data.length">
                        <tr v-for="(item, index) in events.data" :key="index" :class="{'inactive': item.status === '0'}">
                            <td> <img :src="item.img_url" alt="event-image" class="table-thumbnail"> </td>
                            <td>{{item.title}}</td>
                            <td>{{item.corporationName}}</td>
                          <td><span v-if="item.isPrivate === 1" class="btn btn-danger btn-sm">Private</span><span class="btn btn-success btn-sm" v-else >Public</span></td>
                            <td>{{item.start_date}}</td>
                            <td>
                                <span class="badge badge-success" v-if="item.status !== '0'"> Active </span>
                                <span class="badge badge-danger" v-else> Inactive </span>
                            </td>
                            <td>
                                <div class="btn-group" role="group">
                                    <button class="btn btn-secondary btn-sm" @click="viewEvent(item)" v-tooltip.top-center="events.tooltips.view"><i class="fa fa-eye"></i></button>
                                    <button class="btn btn-info btn-sm" @click="editEvent(item)" v-tooltip.top-center="events.tooltips.edit"><i class="fa fa-edit"></i></button>
                                    <button v-if="item.status !== '0'" class="btn btn-danger btn-sm" @click="deleteEvent(item, true)" v-tooltip.top-center="events.tooltips.delete"><i class="fa fa-toggle-off"></i></button>
                                    <button class="btn btn-success btn-sm" v-else @click="deleteEvent(item, false)" v-tooltip.top-center="events.tooltips.activate"><i class="fa fa-toggle-on"></i></button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </l-table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    const eventColumns = ['Image', 'Title', 'Corporation', 'Visibility', 'Date', 'Status', 'Operations'];
    export default {
        name: 'Events',
        components: {
            LTable,
        },
        data() {
        return {
            events: {
                tooltips: {
                    view: 'View Event',
                    edit: 'Edit Event',
                    delete: 'Inactivate Event',
                    activate:'Activate Event',
                },
                columns: [...eventColumns],
        tableRowClass: {
            classname: 'badge-warning',
                    classActiveCondition: 'status'
        },
        data: []
    },
          sortOrder: [{id:2, name:'By Date (Desc)'}, {id:1, name:'By Date (Asc)'}, {id:3, name:'By Title'}],
          sortOderId: 1
    }
    },
    methods: {
      changeListOrder(){
        this.$router.push({ name: 'Order Archive Events'})
      },
        fetchEvents () {
            this.$store.dispatch('FETCH_EVENTS')
                    .then((res) => {
                        this.events.data = res;
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
                    , (err) => {
                console.log("err : ", err);
            }
        },
      fetchArchiveorders () {
        this.$store.dispatch('FETCH_ARHIVE_ORDERING')
          .then((res) => {
            console.log('result', res)
            this.sortOderId = res;
          })
          .catch(err => {
            this.sortOderId = 2
            console.log("API error : ", err);
          })
          , (err) => {
          this.sortOderId = 2
          console.log("err : ", err);
        }
      },
        viewEvent(event){
            this.$router.push({ name: 'ViewEvent', params: { id: event.eventId}})
        },
        editEvent(event){
            this.$router.push({ name: 'EditEvent', params: { id: event.eventId}})
        },
        createEvent(){
            this.$router.push({ name: 'CreateEvent'})
        },
      updateOrder(){
        this.$store.dispatch('UPDATE_ARCHIVE_ORDER', this.sortOderId)
          .then((res) => {
            if(res) this.showPopup('Success!', 'Archive Events Ordering Has been updated', 'success', ()=>this.$router.push('/admin/events'))
            else this.showPopup('Error!', 'Unable to process.', 'error')
          })
          .catch(err => {
            this.showPopup('Error!', 'some thing happen wrong', 'error')
            console.log("ADD_FUNNY API error : ", err);
          })
      },
        deleteEvent(event, boolean){
            console.log("event : ", event);
            this.$store.dispatch('DELETE_SELECTED_EVENT', {eventId: event.eventId, isDelete: boolean})
                    .then((res) => {
                        console.log("DELETE_SELECTED_EXPERT API res : ", res);
                        this.fetchEvents();
                    })
                    .catch(err => {
                        console.log("DELETE_SELECTED_EXPERT API error : ", err);
                    })
        },
      showPopup(title, msg, popupType, cb){
        this.$swal( title, msg, popupType
        ).then(res => {
          cb && cb();
          return res
        })
      }
    },
    created() {
        this.fetchEvents();
        // this.fetchArchiveorders();
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Events/Events.vue